import DefaultRulesCell from './DefaultRulesCell'
import messageResource from '../../../../messageResource'
import PtoRulesMixin from './PtoRulesMixin'

class PtoDefaultRulesCell extends DefaultRulesCell {
    constructor() {
        super()

        this.defaultMessage = messageResource.getMessage("pto_rules_editor.default_pto_rules");
        this.mixin = new PtoRulesMixin();
    }
}

export default PtoDefaultRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PtoDefaultRulesCell.js